import { useEffect, useRef } from "react";

const ACTIVITY_EVENTS = ["mousemove", "mousedown", "keydown", "scroll", "touchstart"];

/**
 * Calls onTimeout after `timeoutMs` of no user activity (mouse, keyboard,
 * scroll, touch). Used to back the "Auto-timeout Duration" security setting
 * so an idle admin session actually gets signed out instead of the setting
 * sitting unused in the database.
 *
 * Pass a falsy `timeoutMs` to disable the timer entirely.
 */
export function useIdleLogout(timeoutMs, onTimeout) {
  const timerRef = useRef(null);
  const onTimeoutRef = useRef(onTimeout);
  onTimeoutRef.current = onTimeout;

  useEffect(() => {
    if (!timeoutMs) return undefined;

    const resetTimer = () => {
      if (timerRef.current) clearTimeout(timerRef.current);
      timerRef.current = setTimeout(() => {
        onTimeoutRef.current?.();
      }, timeoutMs);
    };

    ACTIVITY_EVENTS.forEach((event) =>
      window.addEventListener(event, resetTimer, { passive: true })
    );
    resetTimer();

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
      ACTIVITY_EVENTS.forEach((event) =>
        window.removeEventListener(event, resetTimer)
      );
    };
  }, [timeoutMs]);
}

export default useIdleLogout;
